import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Rowbox from '../Common/Rowbox'
import style from './style.module.less'
import { DECORATION_HOT_RING_SERIES, SERIAL_MANAGE } from '@constant'
import Header from '../Common/Header'
import More from '../Common/More'

const Center = ({ list = [] }) => {
  return (
    <div className={style.centerWapper}>
      {list.length ? (
        list.map(({ id, cover_path, title }) => (
          <div className={style.series} key={id}>
            <img className={style.image} src={cover_path} />
            <div className={style.des}>{title}系列</div>
          </div>
        ))
      ) : (
        <>
          <div className={style.empty} />
          <div className={style.empty} />
          <div className={style.empty} />
          <div className={style.empty} />
        </>
      )}
    </div>
  )
}

@inject('decorationStore')
@observer
export default class extends Component {
  render() {
    const { ringSeriesList } = this.props.store
    return (
      <Rowbox
        type={DECORATION_HOT_RING_SERIES}
        store={this.props.store}
        style={{
          flexDirection: 'column',
          height: 'auto',
          padding: '0 8px'
        }}
        vCenter={false}
      >
        <Header title="热门系列" style={{ padding: '0 8px' }} />
        <Center list={ringSeriesList} />
        <More link={SERIAL_MANAGE} text="全部系列" />
      </Rowbox>
    )
  }
}
